var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountValueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7385_25011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8309 16.8583L26.144 14.0579L15.5027 1.17627L4.86133 14.0579L15.5027 26.9396L20.1289 21.3388",
    stroke: "#187C85",
    strokeWidth: 1.12014,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8 11.8176L11.0215 14.0579L15.5021 26.9396L19.9826 14.0579L15.5021 1.17627L13.749 6.21691",
    stroke: "#187C85",
    strokeWidth: 1.12014,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.86133 14.0581H26.144",
    stroke: "#187C85",
    strokeWidth: 1.12014,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5025 9.01709H13.8223",
    stroke: "#187C85",
    strokeWidth: 1.12014,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7017 9.01709H11.0215",
    stroke: "#187C85",
    strokeWidth: 1.12014,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2617 6.77686V8.45707",
    stroke: "#187C85",
    strokeWidth: 1.12014,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2617 9.57715V11.2574",
    stroke: "#187C85",
    strokeWidth: 1.12014,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4634 19.0986H22.7832",
    stroke: "#187C85",
    strokeWidth: 1.12014,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6626 19.0986H19.9824",
    stroke: "#187C85",
    strokeWidth: 1.12014,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2227 16.8584V18.5386",
    stroke: "#187C85",
    strokeWidth: 1.12014,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2227 19.6587V21.3389",
    stroke: "#187C85",
    strokeWidth: 1.12014,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5826 3.97656H23.9023",
    stroke: "#187C85",
    strokeWidth: 1.12014,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7818 3.97656H21.1016",
    stroke: "#187C85",
    strokeWidth: 1.12014,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3418 1.73633V3.41654",
    stroke: "#187C85",
    strokeWidth: 1.12014,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3418 4.53662V6.21684",
    stroke: "#187C85",
    strokeWidth: 1.12014,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90287 24.1392H8.22266",
    stroke: "#187C85",
    strokeWidth: 1.12014,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10209 24.1392H5.42188",
    stroke: "#187C85",
    strokeWidth: 1.12014,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66211 21.8989V23.5791",
    stroke: "#187C85",
    strokeWidth: 1.12014,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66211 24.6992V26.3794",
    stroke: "#187C85",
    strokeWidth: 1.12014,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7385_25011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.4029,
    height: 26.8834,
    fill: "white",
    transform: "translate(4.29883 0.616211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountValueIcon);
export default __webpack_public_path__ + "static/media/account-value-icon.8aadfa72707f9892082cd66a10bbdfb4.svg";
export { ForwardRef as ReactComponent };